import EpdServiceClient from "@/api/EpdServiceClient";
import { Material } from "@/types/Views/MaterialDatabase/Material";
import { defineStore } from "pinia";
import { Ref, ref } from "vue";

export enum Phase {
  A1A3 = 0,
  A1,
  A2,
  A3,
  A4,
  A5,
  B1,
  B2,
  B3,
  B4,
  B5,
  B6,
  B7,
  C1,
  C2,
  C3,
  C4,
  D,
}

export type InspectConstructionProvider = {
  clear: () => void;
  fetchConstructionById: (constructionId: string) => Promise<void>;
  inspectConstructionError: Ref<boolean>;
  inspectConstructionLoading: Ref<boolean>;
  construction?: Ref<Material | undefined>;
};

const useInspectConstructionProvider = defineStore("InspectConstructionProvider", (): InspectConstructionProvider => {
  const inspectConstructionError = ref<boolean>(false);
  const inspectConstructionLoading = ref<boolean>(false);
  const construction = ref<Material>();

  const clear = () => {
    inspectConstructionError.value = false;
    inspectConstructionLoading.value = false;
    construction.value = undefined;
  };

  const fetchConstructionById = async (constructionId: string) => {
    inspectConstructionError.value = false;
    inspectConstructionLoading.value = true;

    try {
      const response = await EpdServiceClient.get(`api/construction/${constructionId}`);

      if (response.status === 200) {
        construction.value = response.data;
      } else {
        construction.value = undefined;
        inspectConstructionError.value = true;
      }
    } catch (err) {
      construction.value = undefined;
      inspectConstructionError.value = true;
      console.error(err);
    }

    inspectConstructionLoading.value = false;
  };

  return {
    clear,
    construction,
    fetchConstructionById,
    inspectConstructionError,
    inspectConstructionLoading,
  };
});

export default useInspectConstructionProvider;
